const sections = document.querySelectorAll( '.bigvid' );
sections.forEach( section => {
    const play = section.querySelector( '.bigvid__play' );
    const video = section.querySelector( '.bigvid__video' );
    play.addEventListener( 'click', () => {
        section.classList.remove( 'unplayed' );
        play.classList.add( 'hidden' );
        video.setAttribute( 'controls', '' );
        video.play();
    }, { once: true } );
} );